import { fetchOembed } from "./../../wix-ricos-common";
import { VIDEO_TYPE } from "./../../ricos-content";
function videoThumbnailStrategy(instance, hasPlugin) {
  if (!instance || !hasPlugin(VIDEO_TYPE)) {
    return {
      config: {}
    };
  }
  return {
    helpers: {
      onVideoSelected: (url, updateEntity) => {
        return typeof url === "string" ? fetchOembed(url, instance).then((oembed) => {
          const { thumbnail_url, thumbnail_height, thumbnail_width, title } = oembed;
          return { thumbnail_url, thumbnail_height, thumbnail_width, video_url: url, title };
        }).then((oembed) => updateEntity({ oembed })).catch(() => updateEntity({ oembed: null })) : Promise.resolve(updateEntity({ oembed: null }));
      }
    },
    config: {}
  };
}
export {
  videoThumbnailStrategy as default
};
//# sourceMappingURL=videoThumbnailStrategy.js.map
